<template>
  <div
    v-if="isModalTriggired"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  >
    <div
      class="bg-white w-full max-w-4xl mx-4 p-6 rounded-xl shadow-lg relative overflow-hidden"
    >
      <button
        @click="$emit('close', false)"
        class="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-2xl font-bold"
      >
        &times;
      </button>

      <h2 class="text-xl font-semibold pt-4 pb-10 text-secondary">
        Reimbursement Information
      </h2>

      <div>
        <div class="flex gap-10 space-x-6 mb-3">
          <div v-for="tab in tabs" :key="tab.key" @click="setTab(tab)">
            <div
              :class="[
                'pb-2 text-sm font-medium transition',
                activeTab === tab.key
                  ? 'border-b-2 border-primary text-orange-500 font-semibold'
                  : 'text-gray-600 hover:text-primary',
              ]"
            >
              {{ tab.label }}
            </div>
          </div>
        </div>
        <hr />
        <component
          class="my-5"
          :is="activePage"
          :itemDataDetails="itemDataDetails"
        ></component>
      </div>
    </div>
  </div>
</template>

<script>
import { watch, ref } from "vue";
import TabBasicDetail from "@/components/partial/Application/SectionTabDetails/TabBasicDetail.vue";
import TabPayment from "@/components/partial/Application/SectionTabDetails/TabPayment.vue";
import TabAttachment from "@/components/partial/Application/SectionTabDetails/TabAttachment.vue";
import TabActivityLog from "@/components/partial/Application/SectionTabDetails/TabActivityLog.vue";

export default {
  props: {
    itemDataDetails: Object,
    isModalTriggired: Boolean,
  },
  setup(props) {
    const activeTab = ref("basic");
    const activePage = ref(TabBasicDetail);

    watch(
      () => props.isModalTriggired,
      (newVal) => {
        if (newVal) {
          activeTab.value = "basic";
          activePage.value = TabBasicDetail;
        }
      }
    );

    const tabs = [
      { key: "basic", label: "Basic Information", pages: TabBasicDetail },
      { key: "payment", label: "Payment Information", pages: TabPayment },
      { key: "attachment", label: "Documents", pages: TabAttachment },
      { key: "activity", label: "Activity Log", pages: TabActivityLog },
    ];

    const setTab = (tab) => {
      activeTab.value = tab.key;
      activePage.value = tab.pages;
    };
    return {
      tabs,
      activeTab,
      activePage,
      setTab,
    };
  },
};
</script>
